import React from "react"

import {
	DataGrid,
	GridPaginationModel,
	GridSortModel,
} from "@mui/x-data-grid"

import {
	OrderType,
	SearchFilter,
} from "models"
import { PaginationActions } from "components/commons"

import getTaskTableColumns from "./tickets-table-columns"

interface TicketsTableProps
{
	handleCallback: (data: SearchFilter) => void
	data: any | null
}
interface TicketsTableState
{
	pagination: SearchFilter
}
export class TicketsTable extends React.Component<TicketsTableProps, TicketsTableState>
{
	private readonly columns: any

	constructor(props: TicketsTableProps)
	{
		super(props)
		this.columns = getTaskTableColumns()
		this.state = {
			pagination: {
				pageSize: 25,
				pageId: 0,
				orderBy: "id",
				orderType: OrderType.ASCENDING,
			},
		}
	}

	componentDidMount()
	{
		this.props.handleCallback(this.state.pagination)
	}

	private handlePagination = (model: GridPaginationModel) => {
		this.setState(
			() => ({
				pagination: {
					...this.state.pagination,
					pageSize: model.pageSize,
					pageId: model.page,
				},
			}),
			() => this.props.handleCallback(this.state.pagination)
		)
	}

	private handleSorting = (model: GridSortModel) => {
		if(model.length === 0) {
			this.setState(() => ({
				pagination: {
					pageSize: this.state.pagination.pageSize,
					pageId: this.state.pagination.pageId,
					orderBy: null,
					orderType: null,
				},
			}), () => this.props.handleCallback(this.state.pagination))
			return
		}

		let orderType: string | null
		if(model[0].sort === "asc") {
			orderType = OrderType.ASCENDING
		} else if(model[0].sort === "desc") {
			orderType = OrderType.DESCENDING
		} else {
			orderType = null
		}

		this.setState(() => ({
			pagination: {
				pageSize: this.state.pagination.pageSize,
				pageId: this.state.pagination.pageId,
				orderBy: model[0].field,
				orderType: orderType,
			} as SearchFilter,
		}), () => this.props.handleCallback(this.state.pagination))
	}

	render()
	{
		const rows: object[] = []

		if(this.props.data !== null) {
			let i

			for(i = 0; i < this.props.data.items.length; i++) {
				let row = {
					id: this.props.data.items[i].id,
					updates: this.props.data.items[i].updates,
					date: this.props.data.items[i].date,
					status: this.props.data.items[i].status,
					ticketNumber: this.props.data.items[i].ticketNumber,

				}
				rows.push(row)
			}
		}

		// FIXME: replace DataGrid with SbPaginatedDatagrid
		return (
			<DataGrid
				rows={rows}
				columns={this.columns}
				autoHeight
				pagination
				paginationMode="server"
				paginationModel={{ page: this.props.data?.pagination.currentPage || 0, pageSize: this.state.pagination.pageSize }}
				onPaginationModelChange={this.handlePagination}
				rowCount={this.props.data?.pagination.totalRecords || 0}
				pageSizeOptions={[10, 15, 20]}
				sortingMode="server"
				onSortModelChange={this.handleSorting}
				slotProps={{
					pagination: {
						ActionsComponent: PaginationActions
					}
				}}
				disableRowSelectionOnClick
				disableColumnMenu={true}
				sx={{
					bgcolor: "background.default",
					'& .MuiDataGrid-cell:focus': {
						outline: "none"
					}
				}}
				initialState={{
					sorting: {
						sortModel: [{ field: "id", sort: "asc" }],
					},
				}}
			/>
		)
	}
}
